module.exports = __webpack_public_path__ + "static/media/pdf_icon.95b7066b.svg";